<template>
  <div class="container">
    <div class="rufund-info">
      <p>
        <span class="rufund-id">Rufund ID: {{ defaultTips(data.refundId) }}</span>
        <span>Rufund Time: {{ defaultTips(formatTimeStamp(data.refundDate)) }}</span>
      </p>
      <p>
        <span>Refund Amount: {{ `$${defaultTips(data.refundAmount)}` }}</span>
      </p>
    </div>

    <div v-for="(item, index) in data.refunds" :key="index" class="steps">
      <div class="step">
        <div class="step-head">
          <div class="step-icon is-active" />
          <div v-if="index !== data.refunds.length - 1" class="step-line" />
        </div>
        <div class="step-main">
          <p v-if="item.status === 2" :class="['title', 'warning']">{{ `${ordersStatus(item.status)} ${defaultTips(item.refundFailReason)}` }}</p>
          <p v-else class="title">{{ ordersStatus(item.status) }}</p>
          <p class="subheading">{{ `${defaultTips(formatTimeStamp(item.createDate))}` }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatTimeStamp } from '@/utils/moment'

export default {
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {
      formatTimeStamp
    }
  },
  computed: {
    ordersStatus() {
      return (value) => {
        value = Number.parseInt(value)
        switch (value) {
          case 0:
            return 'Refund Application' // 申请退款
          case 1:
            return 'Refund Succeeded' // 退款成功
          case 2:
            return 'Refund Failed' // 退款失败
          default:
            return '-'
        }
      }
    },
    defaultTips() {
      return (value) => value || '-'
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin-bottom: 25px;
  border-bottom: 1px solid #cdd4dd;
  &:last-child {
    margin-bottom: 0;
    border-bottom: 0;
  }
}
.rufund-info {
  margin-bottom: 20px;
  p {
    color: #747a87;
    .rufund-id {
      margin-right: 50px;
    }
    &:first-child {
      margin-bottom: 12px;
    }
  }
}

.steps {
  .step {
    display: flex;
    position: relative;
    height: 68px;
    .step-head {
      height: 100%;
      .step-icon {
        position: absolute;
        top: 2px;
        left: 0;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        border: 1px solid #cdd4dd;
        background-color: #f5f7f7;
        z-index: 1;
        &.is-active {
          border: 1px solid #99c41c;
          background-color: #99c41c;
        }
      }
      .step-line {
        position: absolute;
        top: 2px;
        left: 5px;
        width: 2px;
        height: 100%;
        background-color: #cdd4dd;
      }
    }
    .step-main {
      flex: 1;
      margin-left: 18px;
      .title {
        color: #110808;
        margin-bottom: 5px;
        &.warning {
          color: #eb5757;
        }
      }
      .subheading {
        color: #747a87;
      }
    }
  }
}
</style>
